import { dateProvider } from '@utils';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

import { useCookies } from '.';

const TEST_BANNER_INFO_COOKIE = 'test_banner_info_cookie';
const LAST_BANNER_DISPLAY_COOKIE = 'last_banner_display_date';
const REFERENCE_DATE = new Date('2025-06-30');

export const useTestBannerInfo = () => {
  const now = dateProvider.now();
  const hasOneMonthPassed = dateProvider.diff(REFERENCE_DATE, now, 'months') >= 1;

  const defaultValue = hasOneMonthPassed ? 'true' : Cookies.get(TEST_BANNER_INFO_COOKIE) || 'false';

  const [hasClosedInfoTestBanner, setHasClosedInfoTestBanner] = useCookies(
    TEST_BANNER_INFO_COOKIE,
    defaultValue
  );

  const [isInfoTestBannerOpen, setIsInfoTestBannerOpen] = useState(!hasClosedInfoTestBanner);

  const toggleInfoTestBanner = () => {
    setIsInfoTestBannerOpen(prevState => !prevState);
    setHasClosedInfoTestBanner(isInfoTestBannerOpen);
  };

  useEffect(() => {
    const today = dateProvider.format(now, 'yyyy-MM-dd');
    const lastDisplayDate = Cookies.get(LAST_BANNER_DISPLAY_COOKIE);

    if (
      Cookies.get(TEST_BANNER_INFO_COOKIE) !== 'true' &&
      !hasOneMonthPassed &&
      lastDisplayDate !== today
    ) {
      Cookies.set(LAST_BANNER_DISPLAY_COOKIE, today);
    }
  }, [hasOneMonthPassed]);

  return {
    isInfoTestBannerOpen,
    toggleInfoTestBanner
  };
};
